import { Md5 } from 'ts-md5';

export function getHash(something: unknown): string {
  return Md5.hashStr(JSON.stringify(something));
}
